import { apiSlice } from "../api/apiSlice";

export const participantsSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getParticipants: builder.query({
      query: ({ id }) => `/organisations/${id}/participants`,
      providesTags: (result, error, arg) => [
        { type: "Participant", id: arg?.id },
      ],
    }),
    postParticipant: builder.mutation({
      query: ({ params, body }) => {
        const newBody = { ...body };
        newBody.year_born = body.date_of_birth.split("-")[0];
        return {
          url: `/organisations/${params?.id}/participants`,
          method: "POST",
          body: newBody,
        };
      },
      invalidatesTags: [{ type: "Participant" }],
    }),
  }),
});

export const { useGetParticipantsQuery, usePostParticipantMutation } =
  participantsSlice;
